// TODO fix duplicate enum values
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum ResolverTag {
  ADM = 'adm-logo',
  ADMResponsibleGaming = 'adm-responsible-gaming',
  ANJRGExclude = 'anj-rg-exclude',
  ATSBaseUrl = 'ats-api',
  ATSBootstrap = 'ats-bootstrap',
  ATSCss = 'ats-css',
  AboutRgCashierLogo = 'about-rg-cashier-logo',
  AccountEmailValidationCode = 'account-email-validation-code',
  AccountHistoryStatement = 'account_history_statement',
  AccountPIN = 'pokerstars-pin',
  AccountResponsible = 'account-responsible',
  AddressChangeSupport = 'address-change-support',
  AmountWithdrawHelp = 'wdl-policy-general',
  AvailableWithdrawFaq = 'available-withdraw-faq',
  BeGambleAwareLogo = 'be-gamble-aware-logo',
  BonusWheelGame = 'bonuswheel_game',
  BonusesReleaseAndInstant = 'bonuses-release-and-instant',
  CAONRedirect = 'caon_mob_redirect',
  CAONSignup = 'caon_signup',
  CRMStarCode = 'crm_starcode',
  CSPasswordReset = 'cs-password-reset',
  CSResponsibleExclusion = 'cs-responsible-exclusion',
  Cashbonus = 'cashbonus',
  CasinoAssetWrapper = 'casino-asset-wrapper',
  CasinoRedemption = 'sr_casino_redemption',
  CasinoSlots = 'casino-slots',
  ChestAssets = 'chest_assets',
  CloseAccount = 'cs-account-closure',
  CommunityForumBaseURL = 'CommunityForumBaseURL',
  CommunityForumLoginURL = 'communityforumcustomloginpageurl',
  ConnexOntario = 'connex_ontario',
  ContactSupport = 'contact-support',
  ContactSupportCashierTroubleDeposit = 'contact-support-cashier-trouble-deposit',
  ContactSupportStella = 'contact_support_stella',
  Cookies = 'cookies',
  CustomerVerificationProcess = 'customer_verification_process',
  DFAccountResponsibleGaming = 'about-rg-cashier-logo',
  DFSecuritySecurityDocumentRequest = 'df_security_securitydocumentrequest',
  DKRegulatorLogo = 'dk_dga_logo',
  DKRofusBbr = 'dk-rofus-bbr',
  Davos = 'davos',
  EEPopulationRegister = 'ee_population_register',
  EligibleEula = 'eligible_eula',
  ExchangeHome = 'exchange-home',
  ExchangeMybets = 'exchange-mybets',
  ExchangeWhiteLabel = 'exchange_white_label',
  FacebookSharer = 'facebook_sharer',
  FailedPow = 'failed-pow',
  FreeSpinBonus = 'free-spins-bonuses',
  FreeSpinBonusTermsBonus = 'freespinbonus_terms_bonus',
  FreeSpinBonusTermsBonusCap = 'freespinbonus_terms_bonus_cap',
  FreeSpinBonusTermsCash = 'freespinbonus_terms_cash',
  FreeSpinBonusTermsCashCap = 'freespinbonus_terms_cash_cap',
  FreemiumBuyPlayChips = 'freemium-buy-play-chips',
  GamCareHelplineLogo = 'gamcare-helpline-logo',
  GambanUK = 'gamban_uk',
  GambleAware = 'gamble_aware',
  GamblerLogo800 = '800-gambler-logo',
  GamcareTest = 'gamcare_rgtest',
  GameSecurity = 'df_security_gamesecurity',
  GamingAccountAgreement = 'gaming_account_agreement',
  GamingControlBoard = 'gaming-control-board',
  GamingLabsLogo = 'gaming-labs-logo',
  GeoAssist = 'geo-assist',
  GordonMoodyLogo = 'gordon-moody-logo',
  GrLimitNotIfPrompt = 'gr-limitnotif-prompt',
  HcCurrencyMgt = 'hc_currency_mgt',
  HcTransfersIssues = 'hc-transfers-issues',
  HelpArticlesSportsMaintenance = 'help-articles-sports-maintenance',
  HelpCenter = 'help-center',
  HelpCenterAccVerif = 'help-center-accverif',
  HelpCenterAccountValidation = 'help_center_account_validation',
  HelpCenterChatBotScript = 'hc-chat-bot-script',
  HelpCenterChatBotUrl = 'hc-chat-bot-url',
  HelpCenterDepositDeletingUpdatingCardDetails = 'hc-dep-deleting-updating-card-details',
  HelpCenterDepositWithdrawal = 'hc_dep_wd',
  HelpCenterESDecree = 'help-center-esdecree',
  HelpCenterFeedback = 'hc-feedback',
  HelpCenterP2pTransfer = 'hc_transf',
  HelpCenterSpendBudget = 'hc-spendbudget',
  HelpCenterSpendBudgetArticle = 'hc-spendbudgetarticle',
  HelpCenterWithdrawalFrequency = 'help_withdrawal_frequency',
  HelpEmails = 'help_emails',
  HelpFaqGeolocation = 'help_faq_geolocation',
  HelpGameSportsRules = 'help_games_sports_rules',
  HelpGamecare = 'help_gamcare',
  HelpGamesSportsInPlayBettingRules = 'help_games_sports_in_play_betting_rules',
  HelpMGA = 'help_mga',
  HelpMalta = 'help_malta',
  HelpOver18 = 'help_over18',
  HelpRGAccredation = 'help_rg_accredation',
  HelpRGRegulatorSE = 'help_rg_regulator_se',
  HelpRGSE = 'help_rg_se',
  HelpResponsibleGaming = 'help_responsiblegaming',
  HelpRestrictedAccount = 'help-restricted-account',
  HelpSettingLimits = 'help_setting_limits',
  HelpTOS = 'help_tos',
  HelpUpdateDetails = 'help_update_details',
  HomeGamesInvite = 'homegames_invite',
  HorseRacingRules = 'sportsbook-isp-horseracing-rules',
  IGamingOntario = 'igaming-ontario',
  ISPFreeBets = 'ispfreebets',
  ISPStarSubTerms = 'isp-star-sub-terms',
  IbasLogo = 'ibas-logo',
  IbiaLogo = 'ibia-logo',
  Ice2Home = 'ice-home2',
  IceHome = 'ice-home',
  IceLeaderboards = 'ice-leaderboards',
  IdscanHostedUrl = 'idscan-hosted-url',
  IdscanServerUrl = 'idscan-server-url',
  IgoContact = 'igo-contact',
  InstantBonus = 'instant-bonuses',
  InstantBonusPurchase = 'instantbonus_info',
  InstantBonusSplitWagerTermsCash = 'Instantbonus_splitwager_terms_cash',
  InstantBonusSplitWagerTermsCashCap = 'Instantbonus_splitwager_terms_cash_cap',
  InstantBonusSplitwagerTermsCash = 'instantBonus_splitwager_terms_cash',
  InstantBonusSplitwagerTermsCashCap = 'instantbonus_splitwager_terms_cash_cap',
  InstantBonusTermsCash = 'instantbonus_terms_cash',
  InstantBonusTermsCashCap = 'instantbonus_terms_cash_cap',
  InstantBonusTermsPurchase = 'instantbonus_terms_purchase',
  Joueurs = 'joueurs',
  LiveChatSupport = 'live-chat-support',
  Logico = 'assologico-logo',
  LostRSAToken = 'lost_rsa_token',
  MCEula = 'mc_eula',
  MCEulaARStates = 'mc_eula_ar_states',
  MCPrivacy = 'mc_privacy',
  MCVipStore = 'mc_vipstore',
  MTTGameFilters = 'game-filters-template',
  MatchDayMillions = 'matchdaymillions_game',
  MigrationWithdraw = 'migration_withdraw',
  MinigameTicket = 'mini-game-tickets',
  MitIDRedirect = 'mitid-redirect',
  NJDgeLogo = 'nj-dge-logo',
  NPSDismissal = 'stars_nps_dismissal',
  NPSFollowUp = 'stars_nps_follow_up',
  NPSSubmission = 'stars_nps_submission',
  NwWithdrawRestricted = 'nw-withdraw-restricted',
  ONJNLogo = 'onjn-logo',
  OasisReinstate = 'OASIS_reinstate',
  OpenBankidValidation = 'open_bankid_validation',
  OrderRSAToken = 'order-rsa-token',
  PACouncilLogo = 'pa-council-logo',
  PMCPaywall = 'pmc_paywall',
  PRMCasinoPromoTerms = 'prm_casino_promo_terms',
  PRMCasinoRacesIngame = 'prm_casino_races_ingame',
  PRMPSCasinoDownload = 'prm_pscasino_download',
  PRMPowerPath = 'prm_power_path',
  PSDownload = 'ps-download',
  PSMessenger = 'ps-messenger',
  PTBlacklist = 'pt_blacklist',
  PanicButtonHelpArticle = 'de-vegas-panic-button-help-article',
  PayconiqAppUrlAndroid = 'swc_payconiq_app_url_android',
  PayconiqAppUrlIos = 'swc_payconiq_app_url_ios',
  PaymentInstrumentDocuments = 'payment_instrument_documents',
  PickObjectGame = 'pickobject_game',
  PlayTheDeal = 'play-the-deal-webui',
  PlayerFundsProtection = 'playerFundsProtection',
  PlayerLocationCheck = 'player_location_check',
  PlayerLocationCheckv4 = 'player_location_check_v4',
  PlayerProtectionPage = 'player-protection-page',
  PlayingInsightsMvpSurvey = 'playing_insights_mvp_survey',
  PowerPathLobby = 'power-path-web-lobby',
  PowerPathPassesData = 'power-path-the-passes-data-web-lobby',
  ProcessingExchangeTerms = 'processing-exchange-terms',
  ProcessingTime = 'hc-wd-processing-time',
  RG18Logo = 'rg18-logo',
  RGNJOAG = 'rg_njoag',
  RGPage = 'mc_responsible',
  RGQuestion = 'rg_question',
  RGRegulatorSE = 'rg_regulator_se',
  RamConfig = 'ram_config_url',
  RamCounselingCenter = 'ram_counseling_center',
  RamGamblingTherapy = 'ram_gambling_therapy',
  RamUtils = 'ram_require_js',
  RealMoney = 'realmoney',
  RealMoneyAgeVerificationFaq = 'realmoney_ageverification_faq',
  RealMoneyAstropay = 'realmoney_astropay',
  RealMoneyBoleto = 'realmoney_boleto',
  RealMoneyEcheckTerms = 'realmoney_echeck_terms',
  RealMoneyEchecks = 'realmoney_echecks',
  RealMoneyGamersCard = 'realmoney_gamerscard',
  RealMoneyHyperWallet = 'realmoney_hyperwallet',
  RealMoneyMoneyBookers = 'realmoney_moneybookers',
  RealMoneyMuchBetter = 'realmoney_muchbetter',
  RealMoneyMuchBetterSignUp = 'realmoney_muchbetter_signup',
  RealMoneyMuchBetterSignUpGdpr = 'realmoney_muchbetter_signup_gdpr',
  RealMoneyNeteller = 'realmoney_neteller',
  RealMoneyPSRecarga = 'realmoney_psrecarga',
  RealMoneyPStarsTopUp = 'realmoney_pstarstopup',
  RealMoneyPay4Fun = 'realmoney_pay4fun',
  RealMoneyPayNearMe = 'realmoney_paynearme',
  RealMoneyPspayAstropayRate = 'realmoney_pspay_astropay_rate',
  RealMoneyResortsCasino = 'realmoney_resortscasino',
  RealMoneyRicarica = 'realmoney_ricarica',
  RealMoneySecurityFaq = 'realmoney_security_faq',
  RealMoneySkrill1Tap = 'realmoney_skrill1tap',
  RealMoneyTodito = 'realmoney_todito',
  ResortsLogo = 'resorts-logo',
  ResponsibleGamingLogoBe = 'responsible-gaming-logo-be',
  ResponsibleGamingPokerLimit = 'responsible_gaming_poker_limit',
  ResponsibleGamingQuestion = 'cs-responsible-question',
  RoWithHoldingTax = 'ro-withholding-tax',
  Rollback = 'hc-rollback',
  SaGGameRules = 'game-rules-sag',
  SaGLobby = 'spin-and-go-web-lobby',
  SalLgo = 'sal-logo',
  SecAccountRestricted = 'sec_account_restricted',
  SecurityAgeVerification = 'security-age-verification',
  SelfExclusionGamStop = 'self-exclusion-gamstop',
  SelfExclusionInformation = 'self-exclusion-information',
  SelfExclusionMerger = 'self-exclusion-merger',
  SelfExclusionResponsibleGamingFT = 'self-exclusion-rg-page-fulltilt',
  SelfExclusionResponsibleGamingPS = 'self-exclusion-rg-page-ps',
  SicadPT = 'sicad-pt',
  SingleReelGame = 'singlereel_game',
  SolLgo = 'sol-logo',
  SportsBookExchange = 'sportsbook-exchange',
  SportsBookFreeBets = 'sportsbook-freebets',
  SportsCashBonusTerms = 'bonuscash-terms',
  SrijPT = 'srij-logo',
  SrijRIG = 'srij-rig',
  StarCode = 'star-code',
  StarsCrmCdnBaseUrl = 'starscrm_cdn_baseurl',
  StarsRewardsWidgetService = 'starsrewards_widgetservice',
  StarsWeb = 'stars_web',
  StarsWebApi = 'starsweb_api',
  StarsWebCasino = 'starsweb_casino',
  StarsWebMinilobby = 'starsweb_minilobby',
  StarsWebPoker = 'starsweb_poker',
  StarsWebSports = 'starsweb_sports',
  SubmitDocuments = 'submit-documents',
  SubmitDocumentsVerifications = 'submit-documents-verifications',
  SwcCallbackRedirect = 'swc_callback_redirect',
  SwcCallbackRedirectMitId = 'swc_callback_redirect_mitid',
  SwcContactSupportRestrictedAccount = 'swc-contact-support-restricted-account',
  SwcManageCurrencies = 'swc-manage-currencies',
  SwcSubmitDocumentsVerifications = 'swc-submit-documents-verifications',
  SwcWdlTimeframe = 'swc-wdl-timeframe',
  SwcWithdrawalDecline = 'swc-withdrawal-decline',
  TakeTimeToThink = 'take_time_to_think_logo',
  TwitchAuthorize = 'twitch_authorize',
  TwitterShare = 'twitter_share',
  UKGamstopMain = 'uk_gamstop_main',
  UKLicenseAccountNumber = 'uk_license_account_number',
  VanillaDirectStoreLocator = 'vanilla_direct_store_locator',
  VerifyMeAML = 'verify-me-aml',
  WC2FEBalance = 'wc2fe_balance',
  WC2FEConvertCurrencies = 'wc2fe_convert_currencies',
  WC2FEDeposit = 'wc2fe_deposit',
  WC2FEHistory = 'wc2fe_history',
  WC2FEHome = 'wc2fe_home',
  WC2FEPlayMoney = 'wc2fe_playmoney',
  WC2FEPreferredCurrency = 'wc2fe_preferred_currency',
  WebPoker = 'web_poker',
  WebRealMoneyForm = 'web-real-money-form',
  Withdrawal = 'wc2fe_cashout',
  WrmfTelematiciFiscal = 'wrmf_telematici_fiscal',
  XeWebSite = 'xe_web_site'
}
